import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import './Intro.css';

const textVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } }
};

const Intro = () => {
  return (
    <section className="intro-section">
      <div className="intro-content">
        <motion.div 
          className="intro-text-content"
          initial="hidden"
          animate="visible"
          variants={{
            visible: { transition: { staggerChildren: 0.2 } }
          }}
        >
          <motion.span variants={textVariants} className="intro-greeting">Hello there!</motion.span>
          <motion.h1 variants={textVariants} className="intro-title" style={{ fontSize: '4rem', fontWeight: 800, marginBottom: '1.5rem', lineHeight: 1.1 }}>
            I'm <span className="gradient-text">Muqueet</span>.
          </motion.h1>
          <motion.p variants={textVariants} className="intro-description">
            I am a tech enthusiast currently studying at the University of New South Wales (UNSW) and a proud alumnus of University of California, Berkeley, where I majored in Data and Computer Science. Welcome to my digital domain!
          </motion.p>
          <motion.p variants={textVariants} className="intro-description">
            After completing my undergraduate studies at Berkeley, I've embarked on an exciting journey towards a Masters in Computer Science at UNSW. My research interests include Database Systems and Programming Languages. At UNSW, I am a subcommittee member of{' '}
            <a href="https://devsoc.app" className="intro-link" target="_blank" rel="noopener noreferrer">DevSoc</a>'s{' '}
            <a href="https://freerooms.devsoc.app" className="intro-link" target="_blank" rel="noopener noreferrer">Freerooms</a> Mobile Team.
          </motion.p>
        </motion.div>
        
        <motion.div 
          className="intro-image-container"
          initial={{ opacity: 0, scale: 0.8, rotate: -5 }}
          animate={{ opacity: 1, scale: 1, rotate: 0 }}
          transition={{ duration: 1, type: "spring", bounce: 0.4 }}
          whileHover={{ scale: 1.05, rotate: 2 }}
        >
          <div className="intro-image-wrapper">
            <img
              src="/F80E41B8-9FFE-4482-B583-9B0FAD923BB6.PNG"
              alt="Muqueet Mohsen Chowdhury"
              className="intro-image"
            />
          </div>
        </motion.div>
      </div>
      
      <motion.div 
        className="scroll-indicator"
        initial={{ opacity: 0 }}
        animate={{ opacity: 0.7 }}
        transition={{ delay: 1.5, duration: 1 }}
        whileHover={{ opacity: 1, color: "var(--primary-color)" }}
      >
        <span style={{ fontSize: '0.875rem', fontWeight: 500, letterSpacing: '0.05em', textTransform: 'uppercase' }}>Scroll Down</span>
        <motion.div
          animate={{ y: [0, 8, 0] }}
          transition={{ repeat: Infinity, duration: 2, ease: "easeInOut" }}
        >
          <ChevronDown size={24} />
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Intro;
